export function removeHtmlTagsAndSpacesAndReturnLength(input: string): number {
    const cleanedInput = input
        .replace(/data:image\/[a-zA-Z]+;base64,[^"']*/g, '')
        .replace(/<[^>]*>/g, '')
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&ldquo;/g, '"')
        .replace(/&rdquo;/g, '"')
        .replace(/&mdash;/g, '—')
        .replace(/&ndash;/g, '–')
        .replace(/\\s+/g, ' ');

    return cleanedInput.length;
}

export function isValidHexColor(color: string): boolean {
    const regex = /^#([0-9a-f]{3}){1,2}$/i;
    return regex.test(color);
}

export const getColorWithAlpha = (color: string, alpha: number): string => {
    if (!isValidHexColor(color)) {
        throw new Error(`Invalid hex color: ${color}`);
    }
    const hex = color.replace('#', '');
    const r = parseInt(hex.slice(0, 2), 16);
    const g = parseInt(hex.slice(2, 4), 16);
    const b = parseInt(hex.slice(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

export function trimBadgeNumber(badge: number): string {
    if (badge > 99) {
        return '99+';
    }
    return badge.toString();
}
